import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Navbar } from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import Studio from "@/pages/Studio";
import Wardrobe from "@/pages/Wardrobe";
import Credits from "@/pages/Credits";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import SharedOutfit from "@/pages/SharedOutfit";
import Showcase from "@/pages/Showcase";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <Loader2 className="h-8 w-8 text-[#2f74f0] animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}

function Shell() {
  return (
    <div className="min-h-screen bg-background relative">
      <div className="fixed inset-0 grain-overlay z-0" />
      <Navbar />
      <main className="relative z-10 pt-16">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/studio" element={<Protected><Studio /></Protected>} />
          <Route path="/wardrobe" element={<Protected><Wardrobe /></Protected>} />
          <Route path="/credits" element={<Protected><Credits /></Protected>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/share/:shareId" element={<SharedOutfit />} />
          <Route path="/vetrina/:handle" element={<Showcase />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster
          theme="light"
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFDF8",
              border: "1px solid rgba(30,95,224,0.3)",
              color: "#2e2015",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
